const STATUS_MAP = {
  available: { label: "Disponível", color: "#10B981", bg: "#ECFDF5" },
  serving: { label: "Atendendo", color: "#EF4444", bg: "#FEF2F2" },
  paused: { label: "Pausado", color: "#F59E0B", bg: "#FFFBEB" },
  off_duty: { label: "Expediente encerrado", color: "#9CA3AF", bg: "#F3F4F6" },
};

const REASON_LABELS = {
  banheiro: "Banheiro",
  almoco: "Almoço",
  procedimento: "Procedimento particular",
  outro: "Outro",
};

export function StatusBadge({ status, pause_reason, size = "sm", testid }) {
  const s = STATUS_MAP[status] || STATUS_MAP.off_duty;
  const reasonLabel = status === "paused" && pause_reason ? REASON_LABELS[pause_reason] : null;
  const dotSize = size === "lg" ? 12 : 8;
  const textSize = size === "lg" ? "text-sm" : "text-xs";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full px-2.5 py-1 ${textSize} font-medium`}
      style={{ background: s.bg, color: s.color }}
    >
      <span className="rounded-full" style={{ width: dotSize, height: dotSize, background: s.color }} />
      {s.label}
      {reasonLabel && <span className="opacity-80">&nbsp;— {reasonLabel}</span>}
    </span>
  );
}

export const STATUS_LABEL = (s) => (STATUS_MAP[s] || STATUS_MAP.off_duty).label;
export const STATUS_COLOR = (s) => (STATUS_MAP[s] || STATUS_MAP.off_duty).color;
export const PAUSE_REASON_LABEL = (r) => REASON_LABELS[r] || null;
